/* libs */
import React from "react";
import PropTypes from "prop-types";

const Header = props => {
	const { createItem, pluralItemName } = props;

	return (
		<div className="title wrapper ta-center">
			<div>
				<div className="btn-circle m-right" onClick={createItem}>
					<i className="fal fa-plus icon"></i>
				</div>
				<h4 className="collection-title">{pluralItemName}</h4>
			</div>
		</div>
	);
};

Header.propTypes = {
	createItem: PropTypes.func,
	pluralItemName: PropTypes.string,
};

export default Header;
